<template>
	<div class="flsm">
		<div class="banimg">
			<div class="txt">
				<div class="w1200">
					{{$t('xwzx')}}
					<p>not just a customer, but partners</p>
				</div>
			</div>
			<img src="../../assets/img/bg_news.jpg" alt="">
		</div>
		<div class="mbxs">
			<div class="w1100">
				<router-link to='/about'>{{$t('gsjj')}}</router-link>
				<router-link to='/gszl'>{{$t('gszl')}}</router-link>
				<!-- <router-link class="on" to='/news'>{{$t('xwzx')}}</router-link> -->
			</div>
		</div>
        <div class="mbx">
			<div class="flex1 hsbg"></div>
			<div class="w1100">
				<div>
					<router-link to='/'>{{$t('home')}}</router-link>
					<router-link to='/about'>-{{$t('gyKoreSemi')}}</router-link>
					<!-- <router-link to='/news'>-{{$t('xwzx')}}</router-link> -->
					<span>-{{$t('videozxlb2')}}</span>
				</div>
			</div>
			<div class="flex1"></div>
		</div>
        <div class="news-list w1100">
            <div class="video-list">
                <div class="video-item" v-for="(item,index) in videoList" :key="index"  @click="nato(item.id)">
                    <div class="img" :style="{background:`url('${item.image}')  no-repeat`}"></div>
                    <div class="text">{{item.name}}</div>
                </div>
            </div>
        </div>
        <div class="pages">
            <x-pagination @on-change='change' @on-prev='change' @on-next='change' :totalPage='totalPage' :currentPage="page+1"></x-pagination>
        </div>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				zl:false,
				zl1:false,
				xwlist:[],
				page:0,
				totalPage:1,
                videoList:[]
			}
		},
		created() {
			var that=this
			that.page=0
			that.pages()
		},
		methods:{
			change(e){
				// console.log(e)
				var that=this
				that.page=e-1
				that.pages()
			},
			pages(){
                let row = 6;
				var that=this;
                let url = process.env.VUE_APP_SERVICE_URL+"/api/news/listByCategory?page="+this.page+'&row='+6;
				that.$ajax({
					method: 'get',
					url: url,
					headers: {
						'Accept': '*/*',
						'Content-Type': 'application/json, text/plain, */*'
					},
				
				}).then(function(res) {
					that.videoList=res.data.records;
					that.totalPage=Math.ceil(res.data.total / row);
					// console.log(Math.ceil(44 / 10), 44 / 10)
				})
			},
			nato(id){
                this.$router.push('/video-list?id='+id);
            },
		}
	}
</script>

<style lang="scss" scoped>
.flsm{
    .mbxs{
        //margin-bottom: 50px;
    }
    .news-list{
        // padding-bottom: 50px;
        padding: 20px 0px 50px 0px;
        .news-title{
            font-size: 24px;
            color: #333333;
            font-weight: bold;
            width: 65px;
            border-bottom: #4198CC 6px solid;
            margin: 0 auto;
            text-align: center;
            margin-bottom: 59px;
        }
        .more-new-wrap{
            display: flex;
            justify-content: flex-end;
            margin-top: 23px;
            .more-new{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                cursor: pointer;
                width:90px;
                .label{
                    color: #666666;
                    font-size: 15px;
                    margin-right: 6px;
                }
                .arrow {
                    width:17px;
                    height: 15px;
                    background: url("../../assets/img/arrowRightGrey.png") center center no-repeat;
                    background-size: contain;
                }
                &:hover{
                    .label{
                       color: #333333;
                    }
                    .arrow{
                        background: url("../../assets/img/arrowRightBlue.png") center center no-repeat;
                        background-size: contain;
                    }
                }
            }
        }
        .video-list{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            //margin-left: -15px;
            margin-right: -15px;

            .video-item{
                width: 333px;
                height: 279px;
                background: #fff;
                padding:20px;
                box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                border-radius: 5px;
                margin-left: 15px;
                margin-right: 15px;
                cursor: pointer;
                margin-bottom: 20px;
                &:hover{
                    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.2);
                    .text{
                        color:#4198CC
                    }
                }
                .img{
                    background: #999;
                    height: 170px;
                    margin-bottom: 20px;
                    background-position:center center !important;
                    background-size: cover!important;
                }
                .text{
                    height: calc(100% - 190px);
                    color: #191919;
                    font-size: 16px;
                    line-height: 25px;
                    font-weight: bold;
                    text-overflow: -o-ellipsis-lastline;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    line-clamp: 2;
                    -webkit-box-orient: vertical;
                    word-wrap:break-word;
                }
            }
        }   
    }
}
</style>
